module.exports = __webpack_public_path__ + "static/media/Arrow.38d2dd78.png";